module.exports = __webpack_public_path__ + "media/images/bg-3c077a19261032af5a5076c654e479e6.jpg";